import {
  ComunicazioneDTO,
  EnumTipoDestinatarioDTOCodice,
  EnumTipoMittenteDTOCodice,
  TipoComunicazioneDTO,
} from '@framework/api-client';
import { useTranslation } from '@framework/i18n';
import { DividerTitleElement, VerticalSpace } from '@framework/ui';
import { Space, Tag, Typography } from 'antd';
import * as React from 'react';
import { renderPlaceholderText } from '../detail/renderPlaceholderText';
import { CommunicationSubprocedureSelectInput } from './office/CommunicationSubprocedureSelectInput';

const { Text, Title } = Typography;

interface CommunicationTypeFieldProps {
  communication?: ComunicazioneDTO | null;
  communicationType: TipoComunicazioneDTO;
}

/**
 * Campi una comunicazione in base al Tipo di Comunicazione
 */
export function CommunicationTypeFields(props: CommunicationTypeFieldProps) {
  const { communication, communicationType } = props;
  const { t } = useTranslation();

  return (
    <div>
      {communication?.flCaricataManualmente && (
        <>
          <DividerTitleElement
            title={t('communication-type.sender', 'Mittente')}
          />
          <Space wrap>
            <Tag>{communicationType?.tipoMittente?.denominazione}</Tag>
            {communicationType?.tipoMittente?.codice ==
              EnumTipoMittenteDTOCodice.ENDOPROCEDIMENTI_PRIMO_LIVELLO && (
              <CommunicationSubprocedureSelectInput name="idProcedimentoMittente" />
            )}
          </Space>
        </>
      )}

      <DividerTitleElement
        title={t('communication-type.receivers', 'Destinatari')}
      />
      <Space wrap>
        {communicationType.tipoComunicazioneDestinatario?.map(to => (
          <div key={to.idApplicazione}>
            <Tag>{to.tipoDestinatario?.denominazione}</Tag>
            {to.tipoDestinatario?.codice ==
              EnumTipoDestinatarioDTOCodice.ENDOPROCEDIMENTI_PRIMO_LIVELLO && (
              <CommunicationSubprocedureSelectInput name="idDestinatarioEndoprocedimentoPrimoLivello" />
            )}
          </div>
        ))}
      </Space>

      <DividerTitleElement
        title={t('communication-type.message', 'Messaggio')}
      />
      <Title level={4}>
        {renderPlaceholderText(
          communication?.oggetto ?? communicationType.oggetto,
        )}
      </Title>
      <Text>
        {renderPlaceholderText(
          communication?.messaggio ?? communicationType.messaggio,
        )}
      </Text>
      <VerticalSpace />
    </div>
  );
}
